<bit-simple-dialog>
  <bit-icon bitDialogIcon name="bwi-info-circle" class="tw-text-info tw-text-3xl"></bit-icon>
  <span bitDialogTitle
    ><strong>{{ "yourAccountsFingerprint" | i18n }}:</strong></span
  >
  <span bitDialogContent>
    {{ data.fingerprint.join("-") }}
  </span>
  <ng-container bitDialogFooter>
    <a
      bitButton
      href="https://vowkey.com/help/fingerprint-phrase/"
      target="_blank"
      rel="noreferrer"
      buttonType="primary"
      bitDialogClose
    >
      {{ "learnMore" | i18n }}
      <bit-icon name="bwi-external-link" class="bwi-fw"></bit-icon>
    </a>
    <button bitButton type="button" buttonType="secondary" bitDialogClose>
      {{ "close" | i18n }}
    </button>
  </ng-container>
</bit-simple-dialog>
